module.exports = __webpack_public_path__ + "static/img/ZDH.30fa221.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ZDH.png
// module id = fc/t
// module chunks = 18